// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";

// Axios
import Axios from "axios";

Axios.defaults.baseURL = process.env.ORCA_BASE_URL
Axios.defaults.headers.common["accept"] = "application/json";
Vue.prototype.$http = Axios;

// Store
import store from "./config/store";
Vue.prototype.$store = store;

// Moment
import moment from "moment";
Vue.prototype.moment = moment;

// Router
import router from "./router";

// Tailwind
import "@/assets/css/tailwind.css";

// ElementUI
import "element-ui/lib/theme-chalk/index.css";
import Element from "element-ui";
import locale from "element-ui/lib/locale/lang/en";

// Use ElementUI
Vue.use(Element, { locale });

const token = localStorage.getItem("orca.credentials");
if (token) {
  Vue.prototype.$http.defaults.headers.common["Authorization"] =
    "Bearer " + token;
}

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  components: { App },
  template: "<App/>",
  router
});



// WEBPACK FOOTER //
// ./src/main.js